import React, { Component } from "react";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Button from "../../../../shared/button/button";
import ExpansiveTicket from "../../../../shared/ExpansiveTicket/ExpansiveTicket";
import { setStepParticipant, onCancelRelationshipParticipant } from "../../../actions/account-link";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formatDateToLocalDate, isRelationshipStatusInactive } from "../../../shared/utils";
import { dateToHHMM } from "../../../../../js/shared/utils";
import ModalTerms from "./../../../../shared/ModalTerms/ModalTerms";
import { TermsProvider } from "../../../../shared/Terms/TermsProvider";
import { renderTermsDescription } from "../../../shared/terms";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

class AccountLinkCard extends Component {
	constructor() {
		super();
		this.state = {
			term: false,
			ifRenderModalTerms: false
		};
	}

	renderCheckbox() {
		return (
			<Checkbox
				id="term"
				name="term"
				onChange={options => this.setState({ term: options[0].checked })}
				options={[
					{
						label: (
							<span>
								Li e estou de acordo com as{" "}
								<a className="term-link" onClick={() => {
									this.onRenderModalTerms()
									publish(eventType.ACCOUNT_FAMILY, {
										type: ACCOUNT_FAMILY_EVENT.button_rule
									})
								}}>
									regras de utilização
								</a>{" "}
								da Conta Família.
							</span>
						),
						name: "term",
						checked: this.state.term
					}
				]}
			/>
		);
	}

	mountTimelineItems = data => {
		let dataStepInfo = this.getInfoStep(data);
		let timeLine = [
			{
				label: "<strong>Indicação<br />enviada</strong>",
				description: this.formatTimelineItemDescription(
					data.invited,
					data.canceled,
					this.setTimelineItemActiveStatus(data, 0)
				),
				active: dataStepInfo.step > 0
			},
			{
				label: "<strong>Solicitação<br />de vínculo</strong>",
				description: this.formatTimelineItemDescription(
					data.invited && !data.bond && data.canceled ? data.updated : data.bond,
					this.setTimelineItemActiveStatus(data, 1)
				),
				active: this.setTimelineItemActiveStatus(data, 1)
			},
			{
				label: "<strong>Confirmação<br />do gestor</strong>",
				description: this.formatTimelineItemDescription(
					data.bond && !data.sent && data.canceled ? data.updated : data.sent,
					this.setTimelineItemActiveStatus(data, 2)
				),
				active: this.setTimelineItemActiveStatus(data, 2)
			},
			{
				label: "<strong>Em análise na<br />MaxMilhas</strong>",
				description: this.formatTimelineItemDescription(
					data.sent && !data.evaluated && data.canceled ? data.updated : data.evaluated
				),
				active: this.setTimelineItemActiveStatus(data, 3)
			},
			{
				label: "<strong>Vínculo<br />ativado</strong>",
				description: this.formatTimelineItemDescription(data.evaluated),
				active: data.evaluated
			}
		];
		data.canceled && data.evaluated
			? (timeLine = [
				...timeLine,
				{
					label: "<strong>Conta<br />desvinculada</strong>",
					description: this.formatTimelineItemDescription(
						data.canceled,
						data.canceled,
						this.setTimelineItemActiveStatus(data, 4)
					),
					active: data.canceled
				}
			])
			: true;
		return {
			activeColor: "success",
			inactiveColor: "danger",
			activeIcon: "check",
			inactiveIcon: "close",
			lengthMax: timeLine.length === 6,
			parent: {
				className: dataStepInfo.className,
				statusTitle: dataStepInfo.statusTitle,
				currentStep: dataStepInfo.step
			},
			data: timeLine
		};
	};

	formatTimelineItemDescription = (date, cancelationDate, isCanceled) => {
		if (!date) {
			return "";
		}

		date = isCanceled === false ? cancelationDate : date;

		return `${formatDateToLocalDate(date)} <br /> ${dateToHHMM(date)}`;
	};

	setTimelineItemActiveStatus = (data, step) =>
		this.getInfoStep(data).step > step
			? true
			: this.getInfoStep(data).step === step && this.getInfoStep(data).canceled ? false : null;

	getInfoStep = data => {
		switch (data.status.status) {
			case "N":
				return {
					className: "primary",
					statusTitle: "Em negociação",
					step: data.status.subStatus === "inviteSendParticipant" ? 1 : 2
				};
			case "P":
				return {
					className: "warning",
					statusTitle: "Em análise",
					step: 3
				};
			case "A":
				return {
					className: "success",
					statusTitle: "Ativo",
					step: 4
				};
			case "I":
				return {
					className: "",
					statusTitle: "Inativo",
					step: this.calcStepCancelation(data),
					canceled: true
				};
			default:
				return "";
		}
	};

	calcStepCancelation = data => {
		if (!data.bond && data.invited && data.canceled) {
			return 1;
		} else if (!data.bond) {
			return 0;
		} else if (!data.sent && data.bond && data.canceled) {
			return 2;
		} else if (!data.sent) {
			return 1;
		} else if (data.sent && !data.evaluated && data.canceled) {
			return 3;
		} else if (!data.evaluated) {
			return 2;
		}
	};

	onCancelRelationshipParticipant = data => {
		this.props.onCancelRelationshipParticipant({
			relationId: data._id,
			idManager: data.idManager
		});
	};

	onRenderModalTerms = () => {
		this.setState({
			ifRenderModalTerms: !this.state.ifRenderModalTerms
		});
	};

	onUnlinkClick(data) {
		const { dataOffers } = this.props;
		if (
			dataOffers &&
			dataOffers.offers &&
			dataOffers.offers.length &&
			dataOffers.offers.some(offer => offer.status == 2 || offer.status == 3)
		) {
			this.props.toggleCantUnlink();
		} else {
			this.props.toggleUnlink(data);
		}
	}

	render() {
		const { term, ifRenderModalTerms } = this.state;
		const { data } = this.props;

		return (
			<React.Fragment>
				{window.screen.availWidth <= 468 ? (
					<ExpansiveTicket
						timelineConfig={this.mountTimelineItems(data)}
						description={data.status.name}
						partner={data.manager.name}
						key={data._id}
					>
						<div className="row">
							<div className="col-xs-12 col-md-4 column-text account-link-home--text">
								<p>
									CPF <strong>{data.manager.ssn}</strong>
								</p>
							</div>
							<div className="col-xs-12 col-md-4 column-text account-link-home--text account-link-home--text2">
								<p>
									Cidade <strong>{data.manager.city}</strong>
								</p>
							</div>
							{!isRelationshipStatusInactive(data) &&
								data.status.subStatus !== "inviteSendParticipant" && (
									<div className="col-xs-4 text-right account-link-home--trash">
										<i className="icon-trash" onClick={() => this.onUnlinkClick(data)} />
									</div>
								)}
							<div className="col-md-8" />

							{data.status.subStatus == "inviteSendParticipant" && (
								<div className="col-xs-16 col-md-12 account-link-home--term">
									{this.renderCheckbox()}
								</div>
							)}
							{data.status.subStatus == "inviteSendParticipant" && (
								<div className="col-xs-16 text-center account-link-home--buttons">
									<Button
										className="account-link-home--buttom btn-gray-sm-label"
										type="button"
										onClick={() => this.props.toggleReprove(data)}
									>
										Reprovar
									</Button>
									<Button
										className="account-link-home--buttom btn-primary-sm"
										disabled={!term}
										onClick={() => this.props.nextStep(data)}
										type="button"
									>
										Aprovar
									</Button>
								</div>
							)}
						</div>
					</ExpansiveTicket>
				) : (
					<ExpansiveTicket
						timelineConfig={this.mountTimelineItems(data)}
						description={data.status.name}
						partner={data.manager.name}
						key={data._id}
					>
						<div className="row">
							<div className="col-md-4 column-text account-link-home--text">
								CPF
								<p>{data.manager.ssn}</p>
							</div>
							<div className="col-md-4 column-text account-link-home--text">
								Cidade
								<p>{data.manager.city}</p>
							</div>
							<div className="col-md-8" />
							{data.status.subStatus == "inviteSendParticipant" && (
								<div className="col-md-12">{this.renderCheckbox()}</div>
							)}

							{!isRelationshipStatusInactive(data) &&
								data.status.subStatus !== "inviteSendParticipant" && (
									<div className="col-md-8 text-right account-link-home--trash">
										<i className="icon-trash" onClick={() => this.onUnlinkClick(data)} />
									</div>
								)}
							{data.status.subStatus == "inviteSendParticipant" && (
								<div className="col-md-4 text-right">
									<Button
										className="account-link-home--buttom btn-gray-sm-label"
										type="button"
										onClick={() => {
											this.props.toggleReprove(data);
											publish(eventType.ACCOUNT_FAMILY, {
												type: ACCOUNT_FAMILY_EVENT.button_disapprove_indication
											})
										}}
									>
										Reprovar
									</Button>
									<Button
										className="account-link-home--buttom btn-primary-sm"
										disabled={!term}
										onClick={() => {
											this.props.nextStep(data);
											publish(eventType.ACCOUNT_FAMILY, {
												type: ACCOUNT_FAMILY_EVENT.button_accept_indication
											})
										}}
										type="button"
									>
										Aprovar
									</Button>
								</div>
							)}
						</div>
					</ExpansiveTicket>
				)}
				{ifRenderModalTerms && (
					<TermsProvider slug="family-account-participant">
						{({ content, loading, error }) => (
							<ModalTerms
								ifShow={ifRenderModalTerms}
								onClose={this.onRenderModalTerms}
								dataDescription={renderTermsDescription({ loading, error, content })}
							></ModalTerms>
						)}
					</TermsProvider>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	...state.AccountLink
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			onCancelRelationshipParticipant,
			setStepParticipant
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkCard);
